import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    emptyListCopy: string;
    emptyListTitle: string;
    emptyListCta: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Empty state description text */
            emptyListCopy: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "EmptyList.emptyListCopy?c=wpaj1amd7xa7", defaultMessage: "New activity on your account will show here." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Empty state title */
            emptyListTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "EmptyList.emptyListTitle?c=dt7zti1i9rp4", defaultMessage: "No Updates Yet" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Empty state call-to-action button (empty by default) */
            emptyListCta: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "EmptyList.emptyListCta?c=27k1wwwhf13t", defaultMessage: "" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
